export enum PausePhotoType {
  VehicleParking = 0,
  OverNightOdometer = 1,
  ResumeOdometer = 2,
  Breakdown = 3,
}
